module.exports = __webpack_public_path__ + "img/public/SiteIcons/linkedInIconBlack.svg?2b275bb7";